import { useState, useEffect } from 'react';
import { api } from '@/api/client';

interface AuthImageProps {
  src: string;
  alt: string;
  className?: string;
}

/**
 * Image component that loads images through authenticated API requests.
 * Creates a blob URL from the fetched image data.
 */
export function AuthImage({ src, alt, className }: AuthImageProps) {
  const [blobUrl, setBlobUrl] = useState<string | null>(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    let cancelled = false;

    const loadImage = async () => {
      try {
        const response = await api.get(src, {
          responseType: 'blob',
        });

        if (cancelled) return;

        const url = URL.createObjectURL(response.data);
        setBlobUrl(url);
      } catch (err) {
        if (!cancelled) {
          setError(true);
        }
      }
    };

    loadImage();

    return () => {
      cancelled = true;
      if (blobUrl) {
        URL.revokeObjectURL(blobUrl);
      }
    };
  }, [src]);

  // Cleanup blob URL on unmount
  useEffect(() => {
    return () => {
      if (blobUrl) {
        URL.revokeObjectURL(blobUrl);
      }
    };
  }, [blobUrl]);

  if (error) {
    return (
      <div className={className + ' bg-muted flex items-center justify-center text-muted-foreground text-xs'}>
        Ошибка загрузки
      </div>
    );
  }

  if (!blobUrl) {
    return (
      <div className={className + ' bg-muted animate-pulse'} />
    );
  }

  return (
    <img
      src={blobUrl}
      alt={alt}
      className={className}
    />
  );
}
